export const LOAD_INSIGHTS_SUCCESS = 'INSIGHTS_LOAD_INSIGHTS_SUCCESS';
export const LOAD_INSIGHTS_FAILURE = 'INSIGHTS_LOAD_INSIGHTS_FAILURE';

export const loadInsightsSuccess = insights => ({
  type: LOAD_INSIGHTS_SUCCESS,
  insights,
});
